<template>
  <modal-template
    ref="modal"
    :title="$t('puzzle.saveTemplateModal.title')"
    type-modal="save_template_modal"
  >
    <div class="modal-content__main">
      <div>
        <label for="templateName">{{ $t('puzzle.saveTemplateModal.name') }}</label>
        <d-form-input
          id="templateName"
          v-model="templateName"
          :placeholder="$t('puzzle.saveTemplateModal.placeholder')"
          @keyup.enter="confirm"
        />
        <small class="text-muted">
          {{ $t('puzzle.saveTemplateModal.hint') }}
        </small>
      </div>
      <puzzle-preview
        v-if="previewTable.length"
        :table="previewTable"
        :rows="initialModel.rows"
        :columns="initialModel.columns"
      />
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button type="button" @click="close" class="btn btn-sm btn-secondary mr-2">
        {{ $t('shared.actions.cancel') }}
      </d-button>
      <d-button
        type="button"
        @click.stop="confirm"
        class="btn btn-sm btn-success"
        :disabled="!templateName.trim()"
      >
        {{ $t('puzzle.saveTemplateModal.save') }}
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';
import PuzzlePreview from '../PuzzlePreview.vue';

export default {
  name: 'SaveTemplateModal',
  props: {
    initialModel: Object,
  },
  components: {
    ModalTemplate,
    PuzzlePreview,
  },
  data() {
    return {
      templateName: '',
    };
  },
  computed: {
    previewTable() {
      if (!this.initialModel?.table) return [];

      return this.initialModel.table.map(cell => ({
        ...cell,
        text: '',
        isAnswer: false,
        children: cell.children?.map(child => ({ ...child, text: '' })) || [],
      }));
    },
  },
  methods: {
    ...mapActions(['setToggle']),
    close() {
      this.templateName = '';
      this.setToggle({ type: 'save_template_modal', bool: false });
    },
    confirm() {
      if (this.templateName.trim()) {
        this.$emit('confirm', this.templateName);
        this.close();
      }
    },
  },
};
</script>
